import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";

const AddRequirementModal = ({
  open,
  onClose,
  selectedStandard,
  tags,
  handleRemoveTag,
  inputValue,
  setInputValue,
  handleKeyDown,
  handleAddRequirement,
  loading,
  addTag,
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleConfirm = () => {
    setConfirmOpen(false);
    handleAddRequirement();
  };

  return (
    <>
      {/* Main Modal */}
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Add Requirement</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Add a new requirement to "<strong>{selectedStandard}</strong>".
          </Typography>

          <Typography variant="body2" sx={{ mb: 0.5 }}>
            Requirement Name
          </Typography>

          <Box
            sx={{
              border: "1px solid #ccc",
              padding: "8px",
              borderRadius: "4px",
              display: "flex",
              flexWrap: "wrap",
              gap: "6px",
              minHeight: "50px",
            }}
          >
            {tags.map((tag, index) => (
              <Box
                key={index}
                sx={{
                  backgroundColor: "#d1fae5",
                  padding: "4px 8px",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  fontSize: "14px",
                }}
              >
                {tag}
                <button
                  onClick={() => handleRemoveTag(tag)}
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  ×
                </button>
              </Box>
            ))}

            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Add new requirements..."
              style={{
                flex: 1,
                minWidth: "120px",
                border: "none",
                outline: "none",
                fontSize: "14px",
              }}
            />
            {inputValue.trim() !== "" && (
              <span
                style={{ cursor: "pointer" }}
                className=" text-blue-500 pr-1 pt-1"
                onClick={addTag}
              >
                + Add
              </span>
            )}
          </Box>
          {inputValue.trim() !== "" && (
            <div className="mb-2 mt-2 gap-1">
              <span style={{ fontSize: "12px" }}>
                To add a new requirement to the list, press <b>"Enter"</b> or
                click on the <b>"+ Add"</b> button.
              </span>
            </div>
          )}
        </DialogContent>
        <DialogActions sx={{ pr: 3, pb: 2 }}>
          <Button
            onClick={onClose}
            sx={{
              color: "#0000a0",
              borderColor: "#0000a0",
              borderRadius: "4px",
              border: "1px solid #0000a0",
              backgroundColor: "transparent",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => setConfirmOpen(true)} // 🔹 open confirm dialog
            disabled={loading || !tags.length > 0 || !selectedStandard}
            variant="contained"
            sx={{ bgcolor: "#0000a0", borderRadius: "4px" }}
          >
            {loading ? "Adding..." : "Add Requirement"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ✅ Confirmation Dialog */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Note*</DialogTitle>
        <DialogContent>
          <Typography>
                Are you sure you want to add the requirement(s) to <strong>{selectedStandard}</strong>?
           
            <br />
             <span className="mb-3 block mt-2 text-red-500 text-[14px]">(Once added, they cannot be deleted. A new standard would need to be created.)</span>

        
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            sx={{ bgcolor: "#0000a0" }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddRequirementModal;
